/* eslint-disable max-len */
import { GradesAndPromotionsFormViewModel } from 'src/types/GradesAndPromotionsFormViewModel';
import { GradesAndPromotionsModel } from 'src/types/GradesAndPromotionsModel';
import { ApiResponseModel } from '../types/ApiResponseModel';
import { DataRequestConfig } from '../types/DataRequestConfig';
import { SelectOption } from '../types/SelectOption';
import { getApiBaseUrl } from './app.service';
import { executeApiRequest, getAuthToken } from './base.service';
import { getHttpClient, HttpClient } from './httpClient';

export const gradesAndPromotionsApiPaths = {
  create: 'gradesAndPromotions',
  update: 'gradesAndPromotions',
  getSchoolYearListItems: 'gradesAndPromotions/getSchoolYearListItems',
  getById: (gradesAndPromotionsId: string): string =>
    `gradesAndPromotions/${gradesAndPromotionsId}`,
  getForm: 'gradesAndPromotions/form',
  getStudentByMsisId: (msisId: string, schoolYear: string): string =>
    `gradesAndPromotions/${msisId}/${schoolYear}`,
  getSchoolYears:
    'common/schoolyearsbymodule/formview/GradesAndPromotions?showLongYears=true',
};

export const GradesAndPromotionsServiceClient = (
  config?: DataRequestConfig
): HttpClient =>
  getHttpClient(getApiBaseUrl(), getAuthToken() || '', config?.signal);

export const createGradesAndPromotions = async (
  body: GradesAndPromotionsModel,
  config?: DataRequestConfig
): Promise<ApiResponseModel<string>> => {
  return executeApiRequest<string>(async () => {
    return await GradesAndPromotionsServiceClient(config).post(
      gradesAndPromotionsApiPaths.create,
      body
    );
  });
};

export const updateGradesAndPromotions = async (
  body: GradesAndPromotionsModel,
  config?: DataRequestConfig
): Promise<ApiResponseModel<unknown>> => {
  return executeApiRequest<unknown>(async () => {
    return await GradesAndPromotionsServiceClient(config).put(
      gradesAndPromotionsApiPaths.update,
      body
    );
  });
};

export const getGradesAndPromotionstById = async (
  gradesAndPromotionsId: string,
  config?: DataRequestConfig
): Promise<ApiResponseModel<GradesAndPromotionsModel>> => {
  return executeApiRequest<GradesAndPromotionsModel>(async () => {
    return await GradesAndPromotionsServiceClient(config).get(
      gradesAndPromotionsApiPaths.getById(gradesAndPromotionsId)
    );
  });
};

export const getGradesAndPromotionsFormViewModel = async (
  config?: DataRequestConfig
): Promise<ApiResponseModel<GradesAndPromotionsFormViewModel>> => {
  return executeApiRequest<GradesAndPromotionsFormViewModel>(async () => {
    return await GradesAndPromotionsServiceClient(config).get(
      gradesAndPromotionsApiPaths.getForm
    );
  });
};

export const getStudentByMSISId = async (
  msisId: string,
  schoolYear: string,
  config?: DataRequestConfig
): Promise<ApiResponseModel<GradesAndPromotionsModel>> => {
  return executeApiRequest<GradesAndPromotionsModel>(async () => {
    return await GradesAndPromotionsServiceClient(config).get(
      gradesAndPromotionsApiPaths.getStudentByMsisId(msisId, schoolYear)
    );
  });
};

export const getGradesAndPromotionsSchoolYears = async (
  config?: DataRequestConfig
): Promise<ApiResponseModel<SelectOption[]>> => {
  return executeApiRequest<SelectOption[]>(async () => {
    return await GradesAndPromotionsServiceClient(config).get(
      gradesAndPromotionsApiPaths.getSchoolYears
    );
  });
};
